module.exports = __webpack_public_path__ + "img/icon2.6a37d1b0.png";